<div
  #collapse="ngbCollapse"
  [(ngbCollapse)]="isDrawerCollapsed"
  [animation]="false"
  class="collapse-horizontal h-100 drawer-width shadow-sm"
>
  <ng-content></ng-content>
</div>
<!-- use translate 99% instead of 100% to avoid bug where the button is not strictly side by side with drawer panel and let see through a 1px wide band -->
<button
  class="position-absolute top-0 start-0 btn btn-white border border-light border-2 border-end-0 rounded-end rounded-4 no-shadow py-2 px-3 d-flex align-items-center justify-content-center"
  (click)="collapse.toggle()"
  style="transform: translateX(-99%)"
>
  <svg-icon
    name="arrow"
    [ngClass]="{'mirror-x': isDrawerCollapsed}"
    style="height: 1.6rem;"
  > </svg-icon>
</button>